module.exports = __webpack_public_path__ + "img/Contact_design_s2.c85d9d8d.jpeg";